import { render, staticRenderFns } from "./assCima.vue?vue&type=template&id=3d583a01&scoped=true"
import script from "./assCima.vue?vue&type=script&lang=js"
export * from "./assCima.vue?vue&type=script&lang=js"
import style0 from "./assCima.vue?vue&type=style&index=0&id=3d583a01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d583a01",
  null
  
)

export default component.exports